import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
    >
      <g clipPath="url(#clip0_6007_4206)">
        <g filter="url(#filter0_d_6007_4206)">
          <path
            d="M7 8.84615V51.1538C7 53.2752 9.01797 55 11.5 55H47.5C49.982 55 52 53.2752 52 51.1538V8.84615C52 6.72476 49.982 5 47.5 5H11.5C9.01797 5 7 6.72476 7 8.84615ZM40.75 12.6923H18.25C17.0055 12.6923 16 11.8329 16 10.7692C16 9.70553 17.0055 8.84615 18.25 8.84615H40.75C41.9945 8.84615 43 9.70553 43 10.7692C43 11.8329 41.9945 12.6923 40.75 12.6923Z"
            fill="#33373F"
          />
          <path
            d="M7.28 51.1538V8.84615C7.28 6.91902 9.12976 5.28 11.5 5.28H47.5C49.8702 5.28 51.72 6.91902 51.72 8.84615V51.1538C51.72 53.081 49.8702 54.72 47.5 54.72H11.5C9.12976 54.72 7.28 53.081 7.28 51.1538ZM18.25 12.9723H40.75C42.1063 12.9723 43.28 12.0272 43.28 10.7692C43.28 9.51127 42.1063 8.56615 40.75 8.56615H18.25C16.8937 8.56615 15.72 9.51127 15.72 10.7692C15.72 12.0272 16.8937 12.9723 18.25 12.9723Z"
            stroke="#7E8187"
            strokeWidth="0.56"
          />
        </g>
        <mask
          id="mask0_6007_4206"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="8"
          y="5"
          width="44"
          height="50"
        >
          <path d="M8 5H52V55H8V5Z" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_6007_4206)">
          <path
            d="M48.3422 41.5449C48.3422 44.8479 45.9573 47.8588 42.0567 50.0495C38.1592 52.2385 32.7682 53.5956 26.808 53.5956C20.8478 53.5956 15.4568 52.2385 11.5593 50.0495C7.65868 47.8588 5.27383 44.8479 5.27383 41.5449C5.27383 38.2418 7.65868 35.231 11.5593 33.0402C15.4568 30.8512 20.8478 29.4942 26.808 29.4942C32.7682 29.4942 38.1592 30.8512 42.0567 33.0402C45.9573 35.231 48.3422 38.2418 48.3422 41.5449Z"
            stroke="#464A50"
            strokeWidth="0.2"
          />
        </g>
        <ellipse
          cx="27.1053"
          cy="41.8412"
          rx="11.8543"
          ry="3.5563"
          fill="#2A2D34"
        />
        <path
          d="M42.2112 24.8499L28.5898 16.9856C26.8573 15.9853 24.6372 16.5653 23.6493 18.2764L17.0464 29.7129C16.0585 31.4239 16.6663 33.6366 18.3988 34.6369L32.0202 42.5012C33.7528 43.5015 35.9729 42.9215 36.9608 41.2104L43.5636 29.7739C44.5515 28.0629 43.9438 25.8502 42.2112 24.8499ZM29.2229 23.5004C30.2186 24.0752 30.5567 25.3063 29.989 26.2896C29.4213 27.273 28.1861 27.5957 27.1904 27.0208C26.1947 26.4459 25.8566 25.2149 26.4243 24.2316C26.9921 23.2482 28.2272 22.9255 29.2229 23.5004ZM24.3574 31.9278C22.2564 30.7148 20.5552 29.7982 21.5374 28.0969C22.5196 26.3957 25.0043 25.9553 27.1052 27.1683C29.2062 28.3813 30.0728 30.7435 29.0849 32.4545C28.0687 34.2147 26.4583 33.1408 24.3574 31.9278ZM35.2195 35.5112L32.551 33.9705C31.9735 33.6371 31.8221 32.9335 32.123 32.4123C32.4523 31.8419 33.1588 31.6991 33.6865 32.0038L36.355 33.5445C36.9325 33.8779 37.0839 34.5815 36.783 35.1027C36.4537 35.6731 35.797 35.8446 35.2195 35.5112ZM37.0704 32.3054L33.0875 30.0059C32.51 29.6725 32.3586 28.9689 32.6595 28.4477C32.9888 27.8773 33.6953 27.7345 34.223 28.0392L38.2059 30.3387C38.7834 30.6721 38.9347 31.3758 38.6338 31.8969C38.3827 32.4469 37.6479 32.6389 37.0704 32.3054Z"
          fill="#6D7380"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_6007_4206"
          x="2"
          y="2"
          width="55"
          height="60"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0783854 0 0 0 0 0.100868 0 0 0 0 0.145833 0 0 0 0.62 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6007_4206"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6007_4206"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_6007_4206">
          <rect width="60" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
